import { render, staticRenderFns } from "./FormChecklist.vue?vue&type=template&id=05c080eb"
import script from "./FormChecklist.vue?vue&type=script&lang=js"
export * from "./FormChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormChecklist.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c080eb')) {
      api.createRecord('05c080eb', component.options)
    } else {
      api.reload('05c080eb', component.options)
    }
    module.hot.accept("./FormChecklist.vue?vue&type=template&id=05c080eb", function () {
      api.rerender('05c080eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/components/FormChecklist.vue"
export default component.exports